import React from 'react';
import { Dropdown, DropdownItem, DropdownList, Input } from '@cokitchen/cokitchen-components';
import { ArrowDownIcon } from 'cokitchen-icons';
import { weightMeasurement } from 'utils/constants';
import '../../internal-procurement/new-procurement/styles.scss';
import { AddInternalProcurementType } from 'models/procurement.model';
import useDashboardContext from 'contexts/dashboard.context';
import ActivityIndicator from 'components/base/loader/activityIndicator';

const ExcessReturnsForm = ({
  data,
  index,
  setValue,
  removeItem
}: {
  data: AddInternalProcurementType;
  index: number;
  setValue: (index: number, field: keyof AddInternalProcurementType, value: string) => void;
  removeItem: (index: number) => void;
}) => {
  const { isFetchingFormStoreItems, formStoreItems } = useDashboardContext();
  const getIngredient = (id: string) => formStoreItems?.find((ingredient) => ingredient.id === id);

  const unitType = getIngredient(data?.ingredient_id)?.unit_type;

  return (
    <div className={`add__procurement pb-4 ${index > 0 ? 'pt-6' : ''} border-b border-[#EDEDEE]`}>
      <div>
        <div className='grid grid-cols-2 gap-6 mb-6 flex-wrap'>
          <div>
            <p className='font-medium mb-2'>Item name</p>
            <Dropdown
              content={
                <div className='flex justify-between items-center bg-[#FAFAFA] border-b-[2px] border-b-[#D5D6D7] min-h-[44px] h-auto px-[14px]'>
                  {data?.ingredient_id ? (
                    <div className='text-[#2e3031] flex gap-1 items-center'>
                      <span className='text-[#212224] text-sm'>
                        {getIngredient(data?.ingredient_id)?.name}
                      </span>
                    </div>
                  ) : (
                    <span className='text-[#B5B8BA]'>Select Item name</span>
                  )}
                  <ArrowDownIcon className='h-5 w-5 text-[#95999C]' />
                </div>
              }>
              <DropdownList>
                {isFetchingFormStoreItems ? (
                  <div>
                    <ActivityIndicator />
                  </div>
                ) : formStoreItems?.length > 0 ? (
                  formStoreItems.map((item) => (
                    <DropdownItem key={item.id}>
                      <div
                        className='flex gap-1 items-center'
                        onClick={() => {
                          setValue(index, 'ingredient_id', item.id);
                          setValue(index, 'unit_type', item.unit_type);
                        }}>
                        <span className='text-[#212224] text-sm'>{item.name}</span>
                        {/* <div className='bg-[#DCDBD5] w-[5px] h-[5px] rounded-full' />
                          <span className='text-[#6F7376] text-xs'> {item.price}</span> */}
                      </div>
                    </DropdownItem>
                  ))
                ) : (
                  <h4 className='text-center py-3'>No result</h4>
                )}
              </DropdownList>
            </Dropdown>
          </div>
          <div className='relative'>
            <Input
              design='bordered'
              label='Quantity to return'
              placeholder='00'
              value={data.quantity}
              onChange={(e) => setValue(index, 'quantity', e.target.value)}
            />
            <div className='absolute w-[50px] h-[20px] z-10 rounded-[2px] shadow bottom-[20%] right-[5%]'>
              <Dropdown
                disabled
                content={
                  <div className='h-5 p-1 text-[11px] flex justify-between items-center gap-[2px] cursor-pointer measurement_dropdown'>
                    <span className='text-[#6F7376] truncate capitalize'>
                      {
                        <span className={`text-[#6F7376] truncate ${unitType ? 'capitalize' : ''}`}>
                          {unitType ?? 'Unit(s)'}
                        </span>
                      }
                    </span>
                    {/* <ArrowDownIcon className='w-5 h-5 text-[#96999C]' /> */}
                  </div>
                }>
                <DropdownList>
                  {weightMeasurement.map((item) => (
                    <DropdownItem
                      key={item.value}
                      onClick={() => {
                        return;
                      }}>
                      {item.name}
                    </DropdownItem>
                  ))}
                </DropdownList>
              </Dropdown>
            </div>
          </div>
        </div>
        {index >= 1 && (
          <button
            onClick={() => removeItem(index)}
            className='text-[#E60A2B] mt-2 font-medium text-sm '>
            - Remove Item
          </button>
        )}
      </div>
    </div>
  );
};

export default ExcessReturnsForm;
